import { CardVariant } from "../../../models/CardVariant";
import { MathComparisonSymbol } from "../../../models/Math";
import { IFilterCommand } from "../IFilterCommand";

export type CollectionFilterArgs = {
    collection: Record<string, number> | null | undefined,
    target: number | null | undefined,
    operator: MathComparisonSymbol
}

export class CollectionFilter<TItem extends CardVariant> implements IFilterCommand<TItem, CollectionFilterArgs> {
    isMatch(item: TItem, args: CollectionFilterArgs = { collection: {}, operator: "=", target: null }): boolean {
        // No target provided, so not filtering by collection.
        if (args.target === null || args.target === undefined) {
            return true;
        }

        if (!args.collection) {
            return false;
        }

        const collectionCount = args.collection[item.id] ?? 0;

        switch (args.operator) {
            case '<=':
                return collectionCount <= args.target;
            case '=':
                return collectionCount == args.target;
            case ">=":
                return collectionCount >= args.target;
            case "<":
                return collectionCount < args.target;
            case ">":
                return collectionCount > args.target;
            case "!=":
                return collectionCount != args.target;
            default:
                return false;
        }
    }
}